import { Flex, Typography } from '@banhala/ui-kit';
import type { TwoLineMessageProps } from './types';
import { renderHTMLToText } from '../../../../utils';

export const TwoLineMessage = ({ entity }: TwoLineMessageProps) => {
  if (!entity) {
    return null;
  }

  const { title, description } = entity[0].item;

  const titleElement = title ? renderHTMLToText(title) : null;

  const descriptionElement = description ? renderHTMLToText(description) : null;

  return (
    <Flex.Center padding={{ vertical: 64, horizontal: 16 }}>
      <Flex.Column alignItems="center">
        {titleElement}
        <Typography type="body2" color="content_tertiary">
          {descriptionElement}
        </Typography>
      </Flex.Column>
    </Flex.Center>
  );
};
